// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"EnterCode_noMargin__17I8G","submitContent":"EnterCode_submitContent__3j_FP","submitText":"EnterCode_submitText__3436o"};